import { NAV_GROUPS } from '../components/layout/navConfig';

// Mapa screenId -> label humano, montado a partir do registro único de
// navegação (mesma fonte que Sidebar/breadcrumb/telemetria de escrita usam).
// TELAS_EXTRA (screenId.ts) não tem label — são detalhes/wizards sem entrada
// de menu — então cai no id cru nesse caso, de propósito (não inventa texto).
let cache: Map<string, string> | null = null;

function mapaRotulos(): Map<string, string> {
  if (!cache) {
    cache = new Map(NAV_GROUPS.flatMap((g) => g.itens.map((i) => [i.screenId, i.label] as const)));
  }
  return cache;
}

/** Rótulo humano de uma tela pelo screenId (ranking de Uso). Cai no id cru se
 *  não achar — nunca lança pra chave desconhecida. */
export function rotuloTela(screenId: string): string {
  return mapaRotulos().get(screenId) ?? screenId;
}
